<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg9"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs13"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath23"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path21" /></clipPath></defs><g
     id="g15"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g17"><g
         id="g19"
         clip-path="url(#clipPath23)"><g
           id="g25"
           transform="translate(135.3398,504.5)"><path
             d="m 0,0 h 204.05 c 21.18,0 38.34,-17.16 38.34,-38.34 v -205.02 c 0,-16.03 8.64,-30.82 22.61,-38.68 l 25.28,-14.24 c 13.97,-7.87 22.61,-22.66 22.61,-38.69 v -57.7"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path27" /></g><g
           id="g29"
           transform="translate(448.23,81.8701)"><path
             d="M 0,0 V -36.03 C 0,-57.2 -17.16,-74.37 -38.34,-74.37 h -347.69 c -21.17,0 -38.34,17.17 -38.34,38.34 v 420.32 c 0,21.18 17.17,38.34 38.34,38.34 h 43.14"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path31" /></g><g
           id="g33"
           transform="translate(339.1592,504.5)"><path
             d="M 0,0 H 40.143 C 61.315,0 78.479,-17.164 78.479,-38.336 V -210.3 c 0,-16.031 8.642,-30.816 22.609,-38.684 l 25.282,-14.24 c 13.967,-7.867 22.609,-22.653 22.609,-38.684 V -458.66 c 0,-21.173 -17.164,-38.337 -38.337,-38.337 H 74.489"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path35" /></g><g
           id="g37"
           transform="translate(89.5728,362.7771)"><path
             d="m 0,0 18.727,49.169 c 0.382,0.936 1.707,0.937 2.091,0.003 L 39.375,0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path39" /></g><g
           id="g41"
           transform="translate(95.4131,375.0229)"><path
             d="M 0,0 H 27.789"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path43" /></g><g
           id="g45"
           transform="translate(267.7764,412.6489)"><path
             d="M 0,0 V -49.872"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path47" /></g><g
           id="g49"
           transform="translate(244.1001,387.7131)"><path
             d="m 0,0 c 0,-13.741 -7.627,-24.615 -19.727,-24.826 -4.027,-0.07 -14.437,-0.11 -14.437,-0.11 0,0 -0.065,18.064 -0.065,24.991 0,5.689 -0.036,24.881 -0.036,24.881 H -20.14 C -6.868,24.936 0,13.741 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path51" /></g><g
           id="g53"
           transform="translate(150.2295,412.6489)"><path
             d="m 0,0 v -34.317 c 0,-5.844 2.899,-9.779 7.824,-12.926 2.398,-1.532 5.427,-2.624 9.193,-2.629 3.26,-0.004 5.984,0.751 8.238,1.885 5.739,2.891 9.399,7.28 9.399,13.706 V 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path55" /></g><g
           id="g57"
           transform="translate(294.2148,412.6489)"><path
             d="M 0,0 H 27.542"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path59" /></g><g
           id="g61"
           transform="translate(307.9307,411.0564)"><path
             d="M 0,0 V -48.279"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path63" /></g><g
           id="g65"
           transform="translate(105.5708,330.9634)"><path
             d="M 0,0 H 200.188"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path67" /></g><g
           id="g69"
           transform="translate(150.1309,298.7192)"><path
             d="M 0,0 H 111.068"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path71" /></g></g></g></g></svg>
</template>
